import Vue from 'vue'
import moment from 'moment'

Vue.filter('FormatNetValue', function (value, currency) { // TODO: Needs some work! Account for additional values
  if (value > 999999 && value < 99999999) {
    const formattedValue = (value / 1000000).toFixed(1)
    return `${currency}${formattedValue.toString()}m`
  }
  if (value > 99999999) {
    const formattedValue = (value / 1000000000).toFixed(1)
    return `${currency}${formattedValue.toString()}bn`
  }
  return `${currency}${value}`
})

Vue.filter('FormatNetValueChart', function (value, currency) {
  if (value > 999 && value < 999999) {
    const formattedValue = (value / 1000).toFixed(0)
    return `${currency}${formattedValue.toString()}k`
  }
  if (value > 999999 && value < 99999999) {
    const formattedValue = (value / 1000000).toFixed(1)
    return `${currency}${formattedValue.toString()}m`
  }
  if (value > 99999999) {
    const formattedValue = (value / 1000000000).toFixed(1)
    return `${currency}${formattedValue.toString()}bn`
  }
  return `${currency}${value}`
})

Vue.filter('FormatNumber', function (value) {
  if (value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }
  return ''
})

Vue.filter('formatDate', (date, format) => {
  if (date) return moment(date).format(format)
  return '-'
})
